export const navWidth = '12rem';
// Wide enough for the fields' help icons, which reach ~2rem left of the fields, to clear the nav.
export const navGap = '2.5rem';
